// Models
import { Pattern } from '../../features/session/sessionModels';

// Utilities
import getRemainingNumbers from './getRemainingNumbers';

/**
 * @function getRemainingTotal
 * Calculates how many matches are required for Bingo
 *
 * @param {array} called Numbers called up to this point
 * @param {array} patterns List of game patterns
 * @param {array} numbers Numbers in card
 * @param {array} wildcards Wildcard numbers in card
 * @param {array} daubed Daubed numbers
 * @returns
 */
function getRemainingTotal(
    called: number[],
    patterns: Pattern[],
    numbers: number[],
    wildcards: number[],
    daubed: number[] | false = false,
): [number, number[]] {
    const calledNumbers = numbers.filter((number) => called.includes(number));
    let validNumbers: number[] = [];
    let totalRemaining: number = numbers.length;

    // Loop through each pattern in play
    patterns.forEach(({ pattern }) => {
        // Loop through each variant of a pattern
        pattern.variants.forEach(({ sequence }) => {
            // Get total number of numbers in variant sequence
            const total: number = sequence.pattern.length;
            // Get remaining numbers in variant sequence
            const remainingNumbers: number[] = getRemainingNumbers(
                calledNumbers,
                sequence,
                numbers,
                wildcards,
                daubed,
            );
            const remaining: number = total - remainingNumbers.length;
            const newNumbers: number[] = remainingNumbers.filter(
                (number) => !validNumbers.includes(number),
            );

            validNumbers = [...validNumbers, ...newNumbers];
            totalRemaining =
                remaining < totalRemaining ? remaining : totalRemaining;
        });
    });

    return [totalRemaining, validNumbers];
}

export default getRemainingTotal;
